import React, { useContext } from 'react'

import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import Search from './Search'
import Car from './Car'
import AppContext from './context/AppContext'
import SavedCars from './SavedCars'

const Routed = () => {
	const app = useContext(AppContext);

	if (app.headless) {
		return (
			<Router basename={app.path}>
				<Search />
			</Router>
		)
	} else {
		return (
			<Router basename={app.path}>
				<Switch>
					<Route exact path='/mina-sparade-bilar' children={<SavedCars />} />
					<Route exact path='/:state(nya|begagnade)?/:manufacturer?/:modelSeries?' children={<Search />} />
					<Route path='/:manufacturer/:modelSeries/:slug' children={<Car />} />
				</Switch>
			</Router>
		)
	}
}

export default Routed